module.exports = __webpack_public_path__ + "img/nyjf.6f602810.png";